import React, { useState, useEffect } from "react";
import { Button, Grid, Box, Typography } from "@mui/material";
import { UserApi } from "../../../apis";
import GenericTable from "../../../components/table";
import { useNavigate } from "react-router-dom";
import { convertDateFormatShortYear } from "../../../utils/helpers";


function Phases() {
  const [timeSheet, setTimeSheet] = useState([]);
  const navigate = useNavigate();

  let userId = null;
  try {
    const userString = localStorage.getItem("user");
    const user = JSON.parse(userString);
  } catch (error) {
    console.error("Error parsing user from localStorage:", error);
  }

  // Fetching Time Sheet Data
  const fetchTimeSheet = async () => {
    try {
      const response = await UserApi.getYourTimeSheet();
      const rawData = response.data.data;

      // Log the raw fetched data to check for duplicates from the API

      // Remove duplicates based on 'id'
      const uniqueTimeSheet = [
        ...new Map(rawData.map((item) => [item.id, item])).values(),
      ];

      // Log the unique data after filtering duplicates

      setTimeSheet(uniqueTimeSheet);
    } catch (error) {
    }
  };



  // Define columns for the table
  const columns = [
    { field: "id", headerName: "ID" },
    {
      field: "weekStart",
      headerName: "Week Start",
      width: 120,
      sortable: true,
      renderCell: (params) => (
        <div>
          {convertDateFormatShortYear(params.value)}
        </div>
      ),
    },
    {
      field: "weekEnd",
      headerName: "Week End",
      width: 120,
      sortable: true,
      renderCell: (params) => (
        <div>
          {convertDateFormatShortYear(params.value)}
        </div>
      ),
    },
    { field: "userName", headerName: "Username" },
    { field: "status", headerName: "Status" },
  ];

  // Using useEffect to fetch data on component mount
  useEffect(() => {
    fetchTimeSheet();
  }, []);

  // Handle view action (navigation on click)
  const handleView = (id) => {
    navigate(`/user/view-time-sheet/${id}`);
  };
  const handleAssign = (row) => {
    // Implement the logic for handling the assignment action here
  };

  return (
    <Grid container spacing={3} mt={2} mb={4}>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <Typography variant="h4" fontWeight={600}>
          Manage Time of User
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={6}
        xl={6}
        display="flex"
        justifyContent="flex-end"
      >
        <Button
          variant="contained"
          onClick={() => {
            navigate(`/user/time/add`);
          }}
          color="primary"
        >
          Submit Time
        </Button>
      </Grid>

      <Grid
        item
        xs={12}
      >
        <GenericTable
          data={timeSheet}
          columns={columns}
          isSearchShown={false}
          showAction={false}
        />
      </Grid>
    </Grid>


  );
}

export default Phases;
